export const defaultMemberFormData = {
    givenName: '',
    familyName: '',
    mobileNumber: '',
    homeNumber: '',
    dateOfBirth: '',
    gender: undefined,
    nationalId: '',
    externalId: '',
    address: '',
    suburb: '',
    city: '',
    state: '',
    postCode: '',
    primarySite: '',
    favouriteGenres: [],
    newsletter: false,
    termsAndConditions: false,
    allowThirdPartyContact: false,
    allowThirdPartyProfiling: false,
    captcha: undefined
};
